import React from 'react'
import Typography from '@mui/material/Typography';


const NotFound = () => {
    return (
        <React.Fragment>
            <Typography component="h1" variant="h4" align="center">
                Not Found
            </Typography>

            <br />

            <Typography component="p" align="center">
                The page you are trying to access does not exist as entered.  
                Please click <a href="/home">here</a> to return to the main page.
            </Typography>

            <br />
        </React.Fragment>
        
    );
}


export default NotFound;